import { addSearch } from '../../helpers/pageParamsHelper';

export const refreshPage = (history, params = {}) => {
  const url = addSearch(history.location.pathname, params);
  history.push(url);
};



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_openscap-5.2.2-2.fm3_3.el8.noarch/usr/share/gems/gems/foreman_openscap-5.2.2/webpack/components/IndexTable/IndexTableHelper.js